export const requestEnvironmentAtmaca = (data: any) => ({
  ...data,
  environment: 'Atmaca',
})
